import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const SHEBA_LOGO = 'https://customer-assets.emergentagent.com/job_5ae6b687-efa3-4873-9e8c-8fb765bbdf23/artifacts/3mnvyezt_SHEBA1.jpeg';

/**
 * Slim, permanent prestige strip shown on every public page.
 * Signals authorized international partnership with Sheba Medical Center.
 * Click → navigates to the International Health Access page.
 */
export const ShebaPartnershipBar = ({ onNavigate }) => {
  const { t } = useLanguage();
  const badgeText = t('sheba.badge') || 'AUTHORIZED REPRESENTATIVES OF SHEBA';

  return (
    <div
      className="relative w-full bg-gradient-to-r from-[#0a1628] via-[#0d1a30] to-[#0a1628] border-t border-b border-gold/30"
      data-testid="sheba-partnership-bar"
    >
      {/* Subtle gold hairline glow */}
      <div aria-hidden className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold/60 to-transparent" />
      <div aria-hidden className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />

      <button
        type="button"
        onClick={() => typeof onNavigate === 'function' && onNavigate()}
        className="group w-full flex items-center justify-center gap-3 md:gap-5 px-3 py-2.5 md:py-3 cursor-pointer hover:bg-gold/5 transition-colors"
        data-testid="sheba-partnership-bar-btn"
      >
        {/* Verified shield icon */}
        <span aria-hidden className="hidden sm:inline-flex items-center justify-center w-5 h-5 rounded-full bg-gold/15 border border-gold/40">
          <svg className="w-3 h-3 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </span>

        {/* Label text — localised via t('sheba.badge') */}
        <div className="flex items-center text-center leading-tight">
          <span className="text-[10px] sm:text-xs md:text-sm uppercase tracking-[0.18em] text-[#c9a84c] font-bold">
            {badgeText}
          </span>
        </div>

        {/* Sheba logo */}
        <span className="inline-flex items-center justify-center h-7 md:h-8 px-2 rounded bg-white/95 border border-gold/40 shadow-[0_2px_10px_-2px_rgba(201,168,76,0.35)]">
          <img
            src={SHEBA_LOGO}
            alt="Sheba Global — Tel HaShomer"
            className="h-full w-auto object-contain"
            loading="lazy"
          />
        </span>

        {/* CTA arrow */}
        <span className="hidden md:inline-flex items-center gap-1 text-gold/80 group-hover:text-gold transition-colors">
          <svg className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
          </svg>
        </span>
      </button>
    </div>
  );
};

export default ShebaPartnershipBar;
